export const YOUTUBE = 'youtube';
export const KAKAOTV = 'kakaotv';

export const PLAYLIST = 'playlist';
export const RECOMMEND = 'recommand';



/** WEBPACK FOOTER **
 ** ./src/VO2/libs/constants/index.js
 **/